import LeftNode from './LeftNode'

export default class StarterBooster extends LeftNode {
  constructor() {
    super()
  }

  getChildCandidates () {
    return [] 
  }

  calculateInputData () {
    return null
  }
}
